import { gql } from '@apollo/client';
const REMOVE_MODEL_SPECIFICATION_STATUS = gql `
  mutation RemoveModelSpecificationStatus($statusId: ID!) {
    removeModelSpecificationStatus(statusId: $statusId) {
      removed
    }
  }
`;
export default REMOVE_MODEL_SPECIFICATION_STATUS;
